import { useCampaignMemberSidebarStore } from './campaign-member-sidebar-store';
import { useUserControlsContext } from '../../../contexts/UserControlsContext';
import { CampaignMemberSidebar } from '../../../../../../mini-apps/_shared/components/CampaignMemberSidebar';

/**
 * App-shell host for the in-page campaign member sidebar (U11b, plan
 * 2026-09-24-005 Item G — "Open the member sidebar in-page from every
 * launcher:campaign chip"). Mirrors `EnrollQueueDock`'s mount precedent
 * (AppRouter.tsx): a single instance mounted once above every authenticated
 * route, reading its target from the module-scope
 * `useCampaignMemberSidebarStore` (U11a) rather than being passed props by
 * whichever `launcher:campaign` chip opened it (`StateFactCard`'s
 * `CampaignMemberOpenButton`, StatePills.tsx). Renders nothing when
 * `target` is null — no chip has opened it, or it was just closed.
 *
 * `canManage` mirrors `PlaysSubtab`'s `isMarketingUser || isAdmin` gate for
 * the same underlying "Open in Event Manager" escape hatch pattern (U8's
 * `CampaignDetailSidebar` usage) — marketing users and admins may jump out
 * to Launcher's Event Manager from here too; everyone else gets the
 * read-only view only.
 */
export function CampaignMemberSidebarHost() {
  const target = useCampaignMemberSidebarStore((s) => s.target);
  const close = useCampaignMemberSidebarStore((s) => s.close);
  const { isMarketingUser, isAdmin } = useUserControlsContext();

  if (!target) return null;

  return (
    <CampaignMemberSidebar
      {...target}
      canManage={isMarketingUser || isAdmin}
      onClose={close}
    />
  );
}
